import { Font } from "@react-pdf/renderer";

/**
 * Registers the Inter font family for use with @react-pdf/renderer.
 * Uses @fontsource/inter woff files via jsDelivr CDN.
 * Import this file once in the root PDF Document component (side-effect import).
 */
Font.register({
  family: "Inter",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/inter@5.0.8/files/inter-latin-400-normal.woff",
      fontWeight: 400,
    },
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/inter@5.0.8/files/inter-latin-500-normal.woff",
      fontWeight: 500,
    },
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/inter@5.0.8/files/inter-latin-600-normal.woff",
      fontWeight: 600,
    },
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/inter@5.0.8/files/inter-latin-700-normal.woff",
      fontWeight: 700,
    },
  ],
});

// Disable hyphenation for cleaner print output
Font.registerHyphenationCallback((word) => [word]);
